// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Building from '../_raw/ui/icon_building.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Building);
